/** Tokens visuais — Melhor Envio (marca TNV) */
export {
  CONFIG_ACCENT as ME_ACCENT,
  CONFIG_INK as ME_INK,
  fieldSx,
  saveButtonSx,
  sectionHeaderSx,
  sectionPanelSx,
  stickyFooterSx,
  switchSx,
  infoBannerSx,
} from "./configuracoes.theme";

export const CONFIG_INK = "#1a2035";

export const modalHeaderSx = {
  px: 3,
  py: 2.5,
  flexShrink: 0,
  background: `linear-gradient(135deg, ${CONFIG_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid #F96030`,
};

export const modalDeletePaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxWidth: 480,
  width: "100%",
};

export const oauthButtonSx = {
  borderColor: "#F96030",
  color: "#F96030",
  "&:hover": {
    borderColor: "#e04a1a",
    bgcolor: "rgba(249, 96, 48, 0.06)",
  },
};

export const emptyStateSx = {
  py: 4,
  px: 3,
  textAlign: "center",
  border: "1px dashed",
  borderColor: "grey.300",
  borderRadius: 2,
  bgcolor: "grey.50",
};
